import React from 'react';
import { useLoaderData } from 'react-router-dom';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const Statistics = () => {
    const quize = useLoaderData().data
    return (
        <div className='mx-auto w-75 mt-5 bg-light p-4 rounded'>
            <ResponsiveContainer className='bg-transparent' width={"100%"} height={300}>
                <LineChart
                    width = '500'
                    height= '300'
                    data={quize}
                    >
                    <CartesianGrid strokeDasharray="3 3" />
                    <Line type="monotone" dataKey="total" stroke="#8884d8" activeDot={{ r: 8 }} />
                    <XAxis width='500px' dataKey="name" />
                    <YAxis></YAxis>
                    <Tooltip />
                    <Legend></Legend>
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default Statistics;